
import {Component, Input, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'ngx-validation-message',
  styleUrls: ['./validation-message.component.scss'],
  template: `
      <div class="warning" >
          <span class="caption status-danger mensaje" 
             *ngIf="showMinLength"> Mínimo {{ label }} la longitud es {{ minLength }} simbolos </span>
          <span class="caption status-danger mensaje"
             *ngIf="showMaxLength"> Maximo {{ label }} la longitud es {{ maxLength }} simbolos </span>
          <span class="caption status-danger mensaje" *ngIf="showPattern"> {{ label }} incorrecto  </span>
          <span class="caption status-danger mensaje" *ngIf="showRequired"> {{ label }} es requerido</span>
          <span class="caption status-danger mensaje" *ngIf="showMin"> Valor mínimo de {{ label }} es {{ min }}</span>
          <span class="caption status-danger mensaje" *ngIf="showMax"> Valor maximo de {{ label }} es {{ max }}</span>
      </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgxValidationMessageComponent),
      multi: true,
    },
  ],
})
export class NgxValidationMessageComponent {
  @Input()
  label: string = '';

  @Input()
  showRequired?: boolean;

  @Input()
  min?: number;

  @Input()
  showMin?: boolean;

  @Input()
  max?: number;

  @Input()
  showMax: boolean;

  @Input()
  minLength?: number;

  @Input()
  showMinLength?: boolean;

  @Input()
  maxLength?: number;

  @Input()
  showMaxLength?: boolean;

  @Input()
  showPattern?: boolean;
}
